import React from 'react';

import UpnextSkeletonLoader from 'src/components/thumbnail/thumbnailTypes/Upnext/UpnextSkeletonLoader';
import VerticalSkeletonLoader from 'src/components/thumbnail/thumbnailTypes/Vertical/VerticalSkeletonLoader';

import * as customStyled from './styles';
import { ThumbnailTypes } from '../thumbnail/types';

interface SkeletonRecoTrayProps {
  type: ThumbnailTypes;
}

const SkeletonRecoTray: React.FC<SkeletonRecoTrayProps> = ({ type }) => {
  const renderThumbnails = () => {
    if (type === 'vertical') {
      const thumbnails = new Array(4).fill('recoVerticalThumbnail');
      return thumbnails.map((item, index) => (
        <VerticalSkeletonLoader key={item + index} type="reco" />
      ));
    }
    const thumbnails = new Array(8).fill('recoUpnextThumbnail');
    return thumbnails.map((item, index) => (
      <UpnextSkeletonLoader key={item + index} />
    ));
  };

  return (
    <div css={customStyled.skeletonRecommendedContentContainer}>
      <h3 css={customStyled.skeletonRecommendedContentTitle}></h3>
      <div css={customStyled.recommenededRailContainer}>
        {renderThumbnails()}
      </div>
    </div>
  );
};
export default React.memo(SkeletonRecoTray);
